import { Foundation } from 'foundation-sites';
import jquery from 'jquery';
import pickadate from "pickadate";

window.jQuery = jquery;
window.$ = jquery;

Foundation.addToJquery($);

//jQuery(document).ready($ => ($(document).foundation()));

$(function(){
	// assign app behaviours
	$app.bindLoginAjax();
	$app.calendarLoad();
	$app.search();
	$app.contactOwner();
	$app.imageShift();
	$app.login();
	$app.propertyGallery();
	$app.mobileNav();
	$app.modalOverlay();
	$app.shrinkHeader();
	$app.ticker();
	$app.datePickers();
	$app.scroll();
	$app.greaterThan();
	$app.backLink();
	$app.mapToggle();
	$app.favourites();
	$app.visitWebsite();

	Foundation.Abide.defaults.validators['greater_than'] = $app.greaterThan;
	Foundation.Abide.defaults.validators['checkbox_limit'] = $app.checkboxLimit;

	$(document).foundation();
	
	
	
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/service-worker.js');
	}
	
	  
});

  

var $app = {
	backLink: function() {
		if($('.js-back').length >= 1){
			$('.js-back').on('click', function(e){
				e.preventDefault();
				window.history.back();
				return false;
			})
		}
	},

	bindLoginAjax: function() {
		$('.reveal').on('submit','.js-login-form',function(e){
			e.preventDefault();
		}).on("formvalid.zf.abide",'.js-login-form', function(e,savefrm) {
			var button = $('.js-login-form').find('.button');
			var buttonText = button.val();
			button.val('Logging in...');
			$('.js-form-error, .form-error').fadeOut();
			var data = savefrm.serialize();
			$.ajax({
				method: 'POST',
				url: '/',
				data: data,
				headers: {'Content-Type': 'application/x-www-form-urlencoded'},
				success: function(data) {
					console.log(data);
					if(data.success){
						window.location.replace('/me');
					} else {
						button.val(buttonText);
						/*
						$('.js-form-fields').append('<div class="small-12 columns"><p style="display: none;" class="js-form-error form-error"><i class="fi-alert"></i> '+data.error+'</p></div>');
						$('.js-form-error').fadeIn();
						*/
						var $feedback = '<div class="feedback feedback--error js-feedback text--center"><p>Unable to log in. Your username or password was incorrect.</p><a href="#" class="feedback__dismiss js-feedback-dismiss" title="Close this">&times</a></div>';
						$('.reveal-overlay').append($feedback);

						$('.modal__login-form .form__label').addClass('is-invalid-label').find('input').addClass('is-invalid-input');
					}
				},
				error: function(data) {
					alert("There was a system error\r\n ERR:LOGINFAIL");			
					console.log('error', data);
				},
				dataType: 'json'
			}); 
		});
	},

	greaterThan: function(
		$el,      /* jQuery element to validate */
		required, /* is the element required according to the `[required]` attribute */
		parent    /* parent of the jQuery element `$el` */
		){
		if (!required) return true;
		var from = $el.data("greater-than"),
			to = $el.val();
		return (parseInt(to) > parseInt(from));
	},

	// search behaviours
	search: function(){
		if($('[data-togglefilters]').length >= 1){
			//$('.search__filter-fields').hide();
			$('[data-togglefilters]').off().on('click',function(){
				
				var el = $(this);
			
				$('[data-flyout].active').not(el.next('[data-flyout]')).fadeToggle(150,'linear',function(){
					$(this).removeClass('active');
				})
				el.next('[data-flyout]').fadeToggle(250,'linear').addClass('active');
				
				$('.search__form').foundation("validateForm");
				$(document).foundation();
				
			});

			$('[data-close]').off().on('click',function(e){
				e.preventDefault();
				$(this).parents('[data-flyout]').fadeOut(250,function(){
					$(this).removeClass('active');
				});
			});
			
		}

		$(function(){
			if($('[data-radius]')){
				if($('#search-location').val()==''){
					$('[data-radius]').hide();
				} else {
					$('[data-radius]').show();
				}
			}
		})
	

		if('#search-location'){
			$('#search-location').on('keyup',function(el){
				if($('#search-location').val() != '' && $('[data-radius]').not(':visible')){
					$('[data-radius]').slideDown();
				} else {
					$('[data-radius]').slideUp();
				}
			})
		}
	},

	calendarLoad: function(){
		if($('.js-calendar').length >= 1){
			$('.js-calendar').on('click','.js-calendarUpdate',function(e){
				e.preventDefault();
				// load the calendar into the calendar container
				$('.js-calendar').load($(this).attr('href'));
			})
		};
	},

	checkboxLimit: function($el, required, parent) {
		var group = parent.closest('.checkbox-group');
		var limit = group.attr('data-abide-validator-limit').split(',');
		var min = limit[0];
		var max = limit[1];
		var checked = group.find(':checked').length;
		if (checked == max) {
			// disable unchecked boxes
			group.find(':checkbox:not(:checked)').each(function(){
				$(this).attr('disabled','disabled').parent('label').addClass('disabled');
			});
		} else if (checked >= min && checked <= max) {
		  // clear label highlight
		  group.find('label').each(function() {
			$(this).removeClass('is-invalid-label');
		  });
		  // clear checkbox error and disabled attribute
		  group.find(':checkbox').each(function() {
			$(this).removeClass('is-invalid-input').removeAttr('data-invalid').removeAttr('disabled').parent('label').removeClass('disabled');
		  });
		  group.find('.form-error').hide();

		  return true;
		} else {
		  // label highlight
		  group.find('label').each(function() {
			$(this).addClass('is-invalid-label');
		  });
		  // checkbox error 
		  group.find(':checkbox').each(function() {
			$(this).addClass('is-invalid-input').attr('data-invalid');
		  });
		  group.find('.form-error').show();
		  return false;
		}
	},


	contactOwner: function(){
		if($('.js-contactOwner').length >= 1){
			$('body').on('click','.js-contactOwner',function(e){
				e.preventDefault();
				var propertyId = $(this).data('propertyid');
				$app.showModal('contact-owner/' + propertyId);
			});
		}

		
		$('.reveal').on('submit','.js-contactOwnerForm',function(e){
			e.preventDefault();
			var form = $(this);
			var ref = form.data('ref');
			//alert(ref)
			var url = form.find('[name="action"]').val();
			console.log(url);
			$.ajax({
				type: "POST",
				url: form.url,
				data: form.serialize(),
				complete: function(response){
					console.log(response)
					if(response.status === 200 || response.status === 301 || response.status === 302){
						$('.modal__content').replaceWith('<h1 class="modal__heading">Thank you</h1><div class="small-12 columns"><p>'+response.responseJSON.msg+'</p><p><a class="modal__submit button button--modal" data-close>OK</a></p></div>');
					}
				},
				error: function(response, data, error){
					console.log(data, error)
				},
				success: function(response){
					$('.modal__content').replaceWith('<h1 class="modal__heading">Thank you</h1><div class="small-12 columns"><p>'+response.msg+'</p><p><a class="modal__submit button button--modal" data-close>OK</a></p></div>');
					
					// send event to Google Analtics
					ga('send', 'event', 'Contact owner', 'contact '+ref, 'Contact owner of '+ref);
				},
				dataType: 'json'
				});
				
			return false;
		})
		
	},

	datePickers: function(){
		if($('input[type="date"]').length){			
			var $minDate = new Date();
			var $dateFrom = $('input[name="dateFrom"]').not('[data-inmodal]').pickadate({
					format: 'dd/mm/yyyy',
					formatSubmit: 'dd/mm/yyyy',
					min: $minDate,
					selectYears: true,
					selectMonths: true,
					closeOnSelect: true,
					container: '.site__content',
				}
			).on('change',function($e){
				$('[name="dateTo"]').val('');
				$('[name="dateTo"]').pickadate('picker').set('min',$(this).val());
			});
			var $dateFromDatePicker = $dateFrom.pickadate('picker');

			var $dateTo = $('input[name="dateTo"]').not('[data-inmodal]').pickadate({
				format: 'dd/mm/yyyy',
				formatSubmit: 'dd/mm/yyyy',
				min: $minDate,
				selectYears: true,
				selectMonths: true,
				closeOnSelect: true,
				container: '.site__content',
				}
			);
			var $dateToDatePicker = $dateTo.pickadate('picker');

			
			var $dateFromModal = $('input[name="dateFrom"][data-inmodal]').pickadate({
					format: 'dd/mm/yyyy',
					formatSubmit: 'dd/mm/yyyy',
					min: $minDate,
					selectYears: true,
					selectMonths: true,
					closeOnSelect: true,
					container: '#modal',
				}
			).on('change',function($e){
				//var $dateFromMin = (new Date($dateFromModalDatePicker.get()).getTime())
				//$dateToModalDatePicker.set('min', new Date($dateFromMin));
				$('[name="dateTo"][data-inmodal]').val('');
				$('[name="dateTo"][data-inmodal]').pickadate('picker').set('min',$(this).val());
			});
			var $dateFromModalDatePicker = $dateFromModal.pickadate('picker');

			var $dateToModal = $('input[name="dateTo"][data-inmodal]').pickadate({
				format: 'dd/mm/yyyy',
				formatSubmit: 'dd/mm/yyyy',
				min: $minDate,
				selectYears: true,
				selectMonths: true,
				closeOnSelect: true,
				container: '#modal',
				}
			);
			var $dateToModalDatePicker = $dateToModal.pickadate('picker');
			
		}
	},

	favourites: function(){
		$('body').on('click','.js-favourite',function(e){
			var $i = $(this).find('i');
			var $ref = $(this).data('ref');
			var $id = $(this).attr('id');
			var $pageUrl = window.location.href;
			var $url = $(this).attr('href');
			var $this = $(this)			

			$.ajax({
				type: "GET",
				url: $url,
				complete: function(response) {
					// having to do the update here because the Wishlist plugin is returning a 302 response
					// probably due to using parameterised index.php urls with a querystring
					if(response.status === 200 || response.status === 301 || response.status === 302){
						if($i.hasClass('property__like--liked')){
							// fire unlike event
							//ga('send', 'event', 'Favourites', 'remove '+$ref, 'Unlike '+$ref);
							$this.find('.fa-heart').removeClass('fas').removeClass('property__like--liked').addClass('far');
							//console.log($ref + ' unliked');

						} else {
							// fire like event
							//ga('send', 'event', 'Favourites', 'add '+$ref, 'Like '+$ref);
							$this.find('.fa-heart').removeClass('far').addClass('property__like--liked').addClass('fas');
							//console.log($ref + ' liked');

						}
					}
				},
				success: function(response) {
					if(response.status === 200 || response.status === 301 || response.status === 302){

						if($i.hasClass('property__like--liked')){
							// fire unlike event
							//ga('send', 'event', 'Favourites', 'remove '+$ref, 'Unlike '+$ref);
							$this.find('.fa-heart').removeClass('fas').removeClass('property__like--liked').addClass('far');
							//console.log($ref + ' unliked');

						} else {
							// fire like event
							//ga('send', 'event', 'Favourites', 'add '+$ref, 'Like '+$ref);
							$this.find('.fa-heart').removeClass('far').addClass('property__like--liked').addClass('fas');
							//console.log($ref + ' liked');

						}
					}
				},
				error: function(data,status,error) {
				  
				}
			});	

			e.preventDefault();
		})
	},

	imageShift: function(){
		if($('.js-image-shift').length >= 1){
			$('.js-image-shift').on('mouseenter',function(e){
				$(this).find('.js-shift-target').addClass('shift');
				$('.js-photo-launcher').fadeIn(150);
			}).on('mouseleave',function(e){
				$(this).find('.js-shift-target').removeClass('shift');
				$('.js-photo-launcher').fadeOut(150);
			});
		}
	},


	login: function(){
		if($('.js-login').length >= 1){
			$('.js-login').on('click',function(e){
				e.preventDefault();
				$app.showModal('login');
			});
		}
	},

	mapToggle: function(){
		if($('.js-map-toggle').length >= 1 && $('.js-map-container').length >=1 ){
			$('.js-map-toggle').on('click',function(e){
				e.preventDefault();
				var $state = $(this).data('show');
				if($('.js-map-container').is(':visible')){
					// hide the map and change the state
					$('.js-map-container').slideUp(300,function(){
						$('.js-map-toggle').addClass('search__map-toggle--show').removeClass('search__map-toggle--hide').text('Show map');
					});
				} else {
					// show the map and change the state
					$('.js-map-container').slideDown(300,function(){
						$('.js-map-toggle').addClass('search__map-toggle--hide').removeClass('search__map-toggle--show').text('Hide map');
					});
				}
				return false;
			})
		}
	},
	
	mobileNav: function(){
		$('.js-mobile-nav-toggle').on('click',function(){
			//$('.js-mobile-nav').toggle();
			$('body').toggleClass('show-mobile-nav');
		});

		/*
		$(window).resize(function(){
			$('.js-mobile-nav').css('display','none');
		})
		*/
	},

	propertyGallery: function(){
		if($('.js-launch-gallery').length >= 1){
			$('.js-launch-gallery').on('click',function(e){
				e.preventDefault();
				var $ref = $(this).data('ref');
				//ga('send', 'event', 'View gallery', 'Gallery '+$ref, 'View Gallery '+$ref);

				// make the overlay visible
				$('body').addClass('show-modal').addClass('blur');
				var galleryId = $(this).data('gallery');

				$('.modal__overlay').load('/modals/gallery/' + galleryId, function(){
					//$('.orbit').foundation()
					$('.gallery__slides').cycle({ 
						slides: '>figure',
						caption: '>figure figcaption',
						pager: '.gallery__thumbs-container',
						pagerTemplate: '',
						pagerActiveClass: 'gallery__thumb--active',
						centerHorz: true,
						timeout: 6000,
						speed: 1500,
						manualSpeed: 500,
						log: false
					}); 
				});
			});
		}
	},

	scroll: function() {
		if($('.js-scroll').length >= 1){
			$('.js-scroll').on('click',function(){
				$headerHeight = $('.site__header').css('height');
				$element = $(this).attr('href');
				$([document.documentElement, document.body]).animate({
					scrollTop: $($element).offset().top -160
				}, 1000);
			})
		}
	},

	showModal: function(type){
		
		$('.modal__content').load('/modals/'+type, function(){
			$('body').addClass('blur');
			$('#modal').foundation('open');
		});

		$('#modal').on('open.zf.reveal', function(){
			$(this).foundation();
			$app.datePickers();
		});
		
		$('body').on('closed.zf.reveal', function(){
			$('body').removeClass('blur');	
		});

	},


	modalOverlay: function() {
		/*
		$('body').on('click','[data-modaloverlay]',function(){
			$('body').removeClass('show-modal').removeClass('blur');
		});
		*/

		$('body').on('click','.js-close',function(){
			$('body').removeClass('show-modal').removeClass('blur');
		});
	},


	shrinkHeader: function() {
		$(document).on("scroll", function(){
			if($(document).scrollTop() > 200){
				$('[data-shrink]').addClass('header--shrink');
			}
			else
			{
				$('[data-shrink]').removeClass('header--shrink');
			}
		});
	},

	ticker: function() {
		if($('[data-ticker]').length){
			$('[data-tickeritem]').not(':first').css('display','none');
		}
	},

	visitWebsite: function() {
		if($('.js-visit-website').length){
			$('.js-visit-website').on('click', function(e){
				var $ref = $(this).data('ref')
				//ga('send', 'event', 'External link', 'visit '+$ref, 'Visit website '+$ref);
			})
		}	
	}


}